import React from 'react';
import PropType from 'prop-types';

import AudioPlayerComponentActiveMediaName from './ComponentActiveMediaName';
import AudioPlayerComponentActiveMediaArt from './ComponentActiveMediaArt';
import AudioPlayerComponentActiveMediaControl from './ComponentActiveMediaControl';

/*
 * Active Media Module
 * ---------------------
 * This is the main interactive module in the player, and shows the currently on-air radio show (or podcast, if a podcast is playing)
 * Also houses the player controls
 */
class AudioPlayerComponentActiveMedia extends React.Component {
  render() {
    const dataActiveShow = this.props.dataActiveShow;
    const dataPodcast = this.props.dataPodcast;
    const audioState = this.props.audioState;
    const isExpanded = this.props.isExpanded;
    const isMuted = this.props.isMuted;
    const isPaused = this.props.isPaused;

    const activeMediaClass = isExpanded
      ? `po-audio-player__component-active-media`
      : `po-audio-player__component-active-media row`;

    const colAClasses = isExpanded ? `` : `col-6 col-md-7 order-3`; // NAME MODULE
    const colBClasses = isExpanded ? `` : `col-4 col-md-3 order-11`; // ART MODULE
    const colCClasses = isExpanded ? `` : `col-2 order-1`; // CONTROL MODULE

    const colAStyles = isExpanded ? { display: 'block', width: '100%' } : {}; // NAME MODULE
    const colBStyles = isExpanded ? { display: 'block', width: '100%' } : {}; // ART MODULE
    const colCStyles = isExpanded ? { display: 'block', width: '100%' } : {}; // CONTROL MODULE

    return (
      <div className={activeMediaClass}>
        <div className={colAClasses} style={colAStyles}>
          <AudioPlayerComponentActiveMediaName
            dataActiveShow={dataActiveShow}
            audioState={audioState}
            dataPodcast={dataPodcast}
            isExpanded={isExpanded}
            isMuted={isMuted}
            isPaused={isPaused}
          />
        </div>
        <div className={colBClasses} style={colBStyles}>
          <AudioPlayerComponentActiveMediaArt
            dataActiveShow={dataActiveShow}
            audioState={audioState}
            dataPodcast={dataPodcast}
            handlePlayPause={this.props.handlePlayPause}
            isExpanded={isExpanded}
          />
        </div>
        <div className={colCClasses} style={colCStyles}>
          <AudioPlayerComponentActiveMediaControl
            dataActiveShow={dataActiveShow}
            audioState={audioState}
            dataPodcast={dataPodcast}
            handlePlayPause={this.props.handlePlayPause}
            handleSkipForward={this.props.handleSkipForward}
            handleSkipBackward={this.props.handleSkipBackward}
            handleProgressBarInput={this.props.handleProgressBarInput}
            isExpanded={isExpanded}
          />
        </div>
      </div>
    );
  }
}

AudioPlayerComponentActiveMedia.propTypes = {
  dataActiveShow: PropType.object.isRequired,
  dataPodcast: PropType.object.isRequired,
  audioState: PropType.string.isRequired,
  isExpanded: PropType.bool.isRequired,
  handlePlayPause: PropType.func.isRequired,
  handleSkipForward: PropType.func.isRequired,
  handleSkipBackward: PropType.func.isRequired,
  handleProgressBarInput: PropType.func.isRequired,
  isMuted: PropType.bool,
  isPaused: PropType.bool,
};

export default AudioPlayerComponentActiveMedia;
